import * as React from 'react';
import { getStoreState, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { ButtonIcon } from './components/ButtonIcon';

export const TemplateUIFooterView: React.FunctionComponent = () => {
  const { soundtrack, isPlaying, isMuted } = getStoreState().flyer;
  return (
    <div className="template-ui-footer">
      <ButtonIcon
        icon={isPlaying ? 'pause' : 'play'}
        onClick={() => storeDispatch(Actions.togglePlayback())}
      />
      {soundtrack && (
        <ButtonIcon
          icon={isMuted ? 'unmute' : 'mute'}
          onClick={() => storeDispatch(Actions.toggleAudioMute())}
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controller/TemplateUIFooter.tsx